module.exports = __webpack_public_path__ + "img/disasterRecovery.468d297.svg";